export const templateConstants = {
  GET_DEFAULT_TEMPLATE_BY_EVENT_REQUEST: "GET_DEFAULT_TEMPLATE_BY_EVENT_REQUEST",
  GET_DEFAULT_TEMPLATE_BY_EVENT_SUCCESS: "GET_DEFAULT_TEMPLATE_BY_EVENT_SUCCESS",
  GET_DEFAULT_TEMPLATE_BY_EVENT_FAILURE: "GET_DEFAULT_TEMPLATE_BY_EVENT_FAILURE",

  GET_TEMPLATE_BY_EVENT_REQUEST: "GET_TEMPLATE_BY_EVENT_REQUEST",
  GET_TEMPLATE_BY_EVENT_SUCCESS: "GET_TEMPLATE_BY_EVENT_SUCCESS",
  GET_TEMPLATE_BY_EVENT_FAILURE: "GET_TEMPLATE_BY_EVENT_FAILURE",


  GET_TEMPLATE_REQUEST: "GET_TEMPLATE_REQUEST",
  GET_TEMPLATE_SUCCESS: "GET_TEMPLATE_SUCCESS",
  GET_TEMPLATE_FAILURE: "GET_TEMPLATET_FAILURE",

  CREATE_TEMPLATE_SUCCESS: "CREATE_TEMPLATE_SUCCESS",
  CREATE_TEMPLATE_REQUEST: "CREATE_TEMPLATE_REQUEST",
  CREATE_TEMPLATE_FAILURE: "CREATE_TEMPLATE_FAILURE",

  TOGGLE_MENU_MODAL: "TOGGLE_MENU_MODAL",

  DESKTOP: 'desktop',
  SMARTPHONE: 'smartphone',
  TABLET: 'tablet',

  GETALL_TEMPLATE_REQUEST: "GETALL_TEMPLATE_REQUEST",
  GETALL_TEMPLATE_SUCCESS: "GETALL_TEMPLATE_SUCCESS",
  GETALL_TEMPLATE_FAILURE: "GETALL_TEMPLATE_FAILURE",

  UPDATE_TEMPLATE_REQUEST: "UPDATE_TEMPLATE_REQUEST",
  UPDATE_TEMPLATE_SUCCESS: "UPDATE_TEMPLATE_SUCCESS",
  UPDATE_TEMPLATE_FAILURE: "UPDATE_TEMPLATE_FAILURE",

TOGGLE_PREVIEW_MODE: 'TOGGLE_PREVIEW_MODE',
  DESELECT_SUCCESS: 'DESELECT_SUCCESS',
  SOFT_UPDATE_TEMPLATE: "SOFT_UPDATE_TEMPLATE",
  UNDO_TEMPLATE_CHANGE: "UNDO_TEMPLATE_CHANGE",
  REDO_TEMPLATE_CHANGE: "REDO_TEMPLATE_CHANGE",
  SELECT_TEMPLATE_ELEMENT: "SELECT_TEMPLATE_ELEMENT",
  DELETE_TEMPLATE_ELEMENT_SUCCESS: " DELETE_TEMPLATE_ELEMENT_SUCCESS",

  SET_TEMPLATE_FROM_FORM: 'SET_TEMPLATE_FROM_FORM',
  SET_TEMPLATE_FROM_FORM_REQUEST: 'SET_TEMPLATE_FROM_FORM_REQUEST'
  /*    COPY_SUCCESS: 'COPY_SUCCESS' */
  //and so on
};
